import { parseHtml } from '../../../utils/common'

function Hire(props) {
  let block = props.block

  return (
    <>
      <section className="demand-education-section">
        <div className="demand-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="heading">
                  <h3>{block.short_title}</h3>
                  <h2>{block.title}</h2>
                </div>
              </div>
            </div>
            <div className="row">
              {block?.statistics?.map((element, index) => {
                return (
                  <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
                    <div className="e-demand-box">
                      <div
                        className={`e-demand-inner ${
                          (index + 1) % 2 === 0 ? 'text-green' : null
                        }`}
                      >
                        <h3>{element.numbers}</h3>
                        {element.description
                          ? parseHtml(element.description, true)
                          : ''}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Hire
